import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rewards-tab',
  templateUrl: './rewards-tab.component.html',
  styleUrls: ['./rewards-tab.component.scss'],
})
export class RewardsTabComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
